module.exports = __webpack_public_path__ + "img/conscious-breathing.60411f12.png";